import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { handleCreateSubscription } from '../../common/subscription/SubscriptionService';
import {
  Stack,
  Typography,
  CircularProgress,
  TextField,
  Box,
  Button,
} from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const validationSchema = Yup.object().shape({
  couponCode: Yup.string().required('Required').nullable(),
});

export default function DistrictBillingForm(props) {
  const [errorMessage, setErrorMessage] = useState('');
  const { planCode } = props;

  return (
    <Formik
      initialValues={{
        couponCode: '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        handleCreateSubscription(planCode, '', values.couponCode)
          .then(() => {
            setSubmitting(false);
            props.successAction();
          })
          .catch((err) => {
            let errMsg =
              'An error has occurred, if it persists please contact us'; //Default message
            if (err.response !== undefined) {
              errMsg = err.response.data['Error']
                ? err.response.data['Error']
                : err.response.data['ValidationError']
                ? err.response.data['ValidationError']
                : 'An error has occurred, if it persists please contact us';
            } else if (err.message !== undefined) {
              errMsg = err.message;
            }
            console.error(err);
            console.error(errMsg);
            setErrorMessage(errMsg);
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
        setFieldValue,
      }) => {
        return (
          <Form>
            <Stack alignItems='center' justifyContent='center'>
              <TextField
                name='couponCode'
                type='text'
                label='Sign Up Code'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.couponCode}
                placeholder='Sign Up Code'
                variant='standard'
                error={errors.couponCode && touched.couponCode}
                helperText={touched.couponCode && errors.couponCode}
                sx={{ m: 1, width: '20vw', minWidth: '35ch' }}
                inputProps={{ maxLength: 64 }}
              />
              {errorMessage && (
                <Typography sx={{ color: 'error.main' }}>
                  {errorMessage}
                </Typography>
              )}
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  sx={{ marginTop: 1 }}
                  type={'submit'}
                  disabled={isSubmitting}
                  variant='contained'
                >
                  <PlayCircleOutlineIcon style={{ marginRight: '5' }} />
                  Subscribe
                </Button>
                {isSubmitting && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: 'secondary.main',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-6px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            </Stack>
          </Form>
        );
      }}
    </Formik>
  );
}
